import { LOCALES } from 'src/constants';

const BY_UNITS = ['year', 'placement', 'bush'];

export const getLocaleUnit = (unit: string) => {
  const unitLocale = LOCALES[unit.toUpperCase() as keyof typeof LOCALES] ?? unit;

  return BY_UNITS.includes(unit) ? `${LOCALES.PER} ${unitLocale}` : unitLocale;
};
